import React, {useCallback, useMemo, useState} from 'react';
import {APIProvider, ControlPosition, Map as GoogleMaps} from "@vis.gl/react-google-maps";
import {useQuery} from "@tanstack/react-query";
import corporationService from "../../../../../../services/web/corporation-service.js";
import buildMapMarkers from "./build-map-markers.js";
import NetworkFitBounds from "./network-fit-bounds.jsx";
import NetworkMarkers from "./network-markers.jsx";
import NetworkMarkerInfo from "./network-marker-info.jsx";
import projectUtils from "../../../../../../utils/project-utils.js";

const NetworkMap = ({nodes}) => {
    const [activeMarker, setActiveMarker] = useState(null);

    const {data: corporation} = useQuery({
        queryFn: () => corporationService.entity(),
        queryKey: ["corporation"],
    });

    const markers = useMemo(() => buildMapMarkers(nodes), [nodes]);

    const position = useMemo(() => ({
        lat: parseFloat(corporation?.latitude) || 0,
        lng: parseFloat(corporation?.longitude) || 0,
    }), [corporation]);

    const onSelectMarker = useCallback((marker) => setActiveMarker(marker), []);
    const onClearMarker = useCallback(() => setActiveMarker(null), []);

    if (!corporation) return null;

    return (
        <div className={"relative h-full w-full bg-white"}>
            <APIProvider apiKey={corporation?.maps_api_key ?? ""} language={"pt-BR"} libraries={["places"]}>
                <GoogleMaps
                    mapId={projectUtils.googleMapsIds().default}
                    defaultZoom={14}
                    defaultCenter={position}
                    reuseMaps={true}
                    streetViewControl={false}
                    mapTypeControl={true}
                    scrollwheel={true}
                    gestureHandling={'greedy'}
                    style={{height: "100%", width: "100%"}}
                    fullscreenControlOptions={{position: ControlPosition.BOTTOM_RIGHT}}
                    mapTypeControlOptions={{position: ControlPosition.TOP_RIGHT}}
                >
                    <NetworkFitBounds markers={markers}/>
                    <NetworkMarkers
                        baseMarkers={markers}
                        activeMarker={activeMarker}
                        onSelect={onSelectMarker}
                        onClear={onClearMarker}
                    />
                </GoogleMaps>
            </APIProvider>

            {!markers.length && (
                <div className={"absolute top-2 left-1/2 -translate-x-1/2 z-10 bg-white px-4 py-2 rounded-[5px] shadow-lg text-[13px] text-[#676a6c]"}>
                    Nenhum elemento com localização para exibir no mapa.
                </div>
            )}

            {activeMarker && (
                <NetworkMarkerInfo node={activeMarker.node} onClose={() => setActiveMarker(null)}/>
            )}
        </div>
    );
};

export default NetworkMap;
